window.addEventListener('DOMContentLoaded',function(){
    $(document).ready(function() {

        (function() {
            $.ajax({
                type: 'GET',
                url: '/cart.json?' + Date.now(), 
                dataType: 'json',
                success: function(response) {
                    var items = response.items
                    var hasMainProduct = false
                    items.forEach(function(item) {
                        if (item.properties['Type'] && item.properties['Type'] == 'Main Product') {
                            hasMainProduct = true
                        }
                    })
                    if (!hasMainProduct) {
                        $('.product-action .custom-product__exist').hide()
                        $('.product-action .custom-product__submit').removeClass('hide')
                    }
                }
            });
        })();

        function renderSumaryItem(title, value, image = '') {
            var imageHtml = ''
            if (!image) {
                image = `data:image/svg+xml,%3Csvg%20viewBox%3D%220%200%20200px%20200px%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3C%2Fsvg%3E`
            }
            imageHtml = `<img src="${image}">`
            return `
            <div class="summary-item grid__item small--one-third medium--one-third large--one-quarter widescreen--one-fifth">
                <div class="summary-item__image">
                    ${imageHtml}
                </div>
                <div class="summary-item__title">${title}</div>
                <div class="summary-item__value">${value}</div>
            </div>
            `;
        }

        function renderSelectedOptions() {
            var summaryHtml = '';
            var total = 0
            $('.custom-tabs .tab-item[data-success="1"]').each(function(index, node) {
                var dataId = $(node).data('id')
                var itemTitle = $(node).data('title')
                var node = $('.pannel-item[data-id="' + dataId + '"]').find('.main-item[data-selected="1"]')
                var itemImage = $(node).find('.product-card img').data('src') || ''
                var itemValue = $(node).data('sku') || $(node).data('value')
                var itemPrice = $(node).data('price') || 0

                summaryHtml += renderSumaryItem(itemTitle, itemValue, itemImage)
                total += itemPrice;
            })

            $('.custom-summary .summary-bottom').html(summaryHtml)
            $('.custom-summary .price,.product-single__meta .product-price__price > span').html(theme.Currency.formatMoney(total, theme.moneyFormat))
        }

        function renderSubmitError() {
            var submitError = '';
            $('.custom-tabs .tab-item[data-required=true]').each(function(_, node) {
                var success = $(node).attr('data-success')
                if (success != '1') {
                    var title = $(node).data('title')
                    submitError += `<div class="error-item"><strong>${title}</strong> is required</div>`
                }
            })
            if (submitError) {
                $('.submit-error').html(submitError).show()
            } else {
                $('.custom-product__submit').removeAttr('disabled')
                $('.submit-error').hide()
            }
        }

        $('.custom-items-container').delegate('.tab-item', 'click', function() {
            var dataId = $(this).data('id')
            $('.custom-items-container .tab-item').removeClass('active')
            $(this).addClass('active')
            $('.custom-items-container .pannel-item').removeClass('active')
            $('.pannel-item[data-id="' + dataId + '"]').addClass('active')

            //读取第一个
            var urlCheck = $('.custom-items-container .active').find('.active').data('url-check');
            var text = $('.custom-items-container .active').find('.active').data('text');
            var url = $('.custom-items-container .active').find('.active').data('url');
            if(urlCheck == 1)
            {
                $(".diymore").show();
                $(".diymore").text(text)
                $(".diymore").href(diymore)
            }
            else
            {
                $(".diymore").hide();
            }
        })

        $('.custom-items-container').delegate('.zoom-in', 'click', function(e) {
            e.preventDefault()
            e.stopPropagation()
            var srcZoom = $(this).closest('.main-item').find('img').data('src-zoom')
            $('#zoomImageModal img').attr('src', srcZoom)
            $('.modal-backdrop').show();
            $('#zoomImageModal').show();
        })

        $('#zoomImageModal .js-modal-close').on('click', function() {
            $('#zoomImageModal').hide()
            $('.modal-backdrop').hide();
            $('#zoomImageModal img').attr('src', 'data:image/svg+xml,%3Csvg%20viewBox%3D%220%200%20200px%20200px%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3C%2Fsvg%3E')
        })

        $('.custom-items-container .pannel-item').delegate('.top-item', 'click', function() {
            var dataId = $(this).data('product-id')
            var urlCheck = $(this).data('url-check')
            var text = $(this).data('text')
            var url = $(this).data('url')

            $(this).closest('.pannel-item').find('.top-item').removeClass('active')
            $(this).addClass('active')
            $(this).closest('.pannel-item').find('.main-item-wapper').removeClass('active')
            $(this).closest('.pannel-item').find('.main-item-wapper[data-product-id="' + dataId + '"]').addClass('active')

            if(urlCheck == 1)
            {
                $(".diymore").show();
                $(".diymore").text(text)
                $(".diymore").href(diymore)
            }
            else
            {
                $(".diymore").hide();
            }
        })

        $('.custom-items-container .pannel-item').delegate('.product-card', 'click', function() {
            var variantId = $(this).closest('.main-item').data('variant-id')
            var pannelValue = $(this).closest('.main-item').data('value')
            var pannelId = $(this).closest('.pannel-item').data('id')
            var tabItem = $('.tab-item[data-id="' + pannelId + '"]')
            var mainItem = $(this).closest('.main-item')

            if (tabItem.attr('data-required') == 'false' && mainItem.attr('data-selected') == '1') {
              $(this).closest('.pannel-main').find('.main-item').attr('data-selected', '0')
              $(tabItem).attr('data-success', '0')
              if (variantId) {
                $(tabItem).attr('data-label', '')
                $(tabItem).attr('data-value', '')
              }
              pannelValue = ''
            } else {
              $(this).closest('.pannel-main').find('.main-item').attr('data-selected', '0')
              $(this).closest('.main-item').attr('data-selected', '1')
              if (variantId) {
                  $(tabItem).attr('data-label', variantId)
                  $(tabItem).attr('data-value', pannelValue)
              }
              $(tabItem).attr('data-success', '1')
            }
       
            $(this).closest('.pannel-main').find('.choice').html(pannelValue);
            renderSelectedOptions();
            renderSubmitError();
        })


        $('.custom-product__submit').on('click', function(e){
            e.preventDefault();
            e.stopPropagation();

            var success = $('.tab-item[data-required=true]').length > 0
            $('.tab-item[data-required=true]').each(function(_, node) {
              if ($(node).data('success') != '1') {
                success = false
              }
            })
            if (!success) {
              renderSubmitError();
              return
            }

            var items = []

            // push main product
            var main = {
                id: $('select[name="id"]').val(),
                quantity: 1,
                properties: {
                    'Type': 'Main Product'
                }
            }

            // push accessory product
            var accessories = [];
            $('.tab-item').each(function(index, node) {
                var variantId = $(node).data('label')
                var title = $(node).data('title')
                var value = $(node).data('value')
                if (!value) {
                    return;
                }
                main.properties[title] = value;
                if (!variantId) {
                    return;
                }
                accessories.push({
                    id: variantId,
                    quantity: 1,
                    properties: {
                        'Type': 'Accessory Product',
                        'Main Product ID': main.id
                    }
                })
            })


            var engValue = $('.eng-header .eng-input').val()
            if (engValue) {
                main.properties['Engraving'] = engValue;
            }
            
            items.push(main, ...accessories)
            $.ajax({
                type: 'POST',
                url: '/cart/add.js', 
                data: {
                    items: items
                },
                dataType: 'json',
                success: function() {
                    window.location.href = '/cart'
                }
            });
        });
    });
});